module.exports = __webpack_public_path__ + "static/media/logo_ministero_turismo.e60940aa.webp";